<div row-layout gap="md" alignItems="center">
  @if (auth.isAuthenticated()) {
    <div>
      <Menu [menuItems]="menuItems">
        <button
          text-button
          variant="ghost"
          symbolLeft="shield_person"
          symbolRight="arrow_drop_down"
        >
          {{ auth.userName() }}
        </button>
      </Menu>
    </div>
    @if (regions.selectedRegion()) {
      <div>
        @if (regionMenuItems().length > 1) {
          <Menu [menuItems]="regionMenuItems()">
            <button
              text-button
              variant="ghost"
              symbolLeft="public"
              symbolRight="arrow_drop_down"
            >
              {{ regions.selectedRegion()?.label }}
            </button>
          </Menu>
        } @else {
          <div row-layout alignItems="center" gap="sm">
            <Symbol name="public" />
            <Text display="block">
              {{ regions.selectedRegion()?.label }}
            </Text>
          </div>
        }
      </div>
    }
  } @else {
    <button text-button variant="ghost" (click)="auth.signIn()">Sign in</button>
  }
</div>
